import { CutStringPipe } from "@nms-ng2/app/shared/pipes/cut-string.pipe";
import { IntermediateDevice } from "../../wizard/steps/3-intermediates/intermediates-step.model";
import { AmplifierDirectionMap, OscPositionMap } from "../models/diagram.models";
import { DwdmDiagramConverterHelper } from "./dwdm-diagram-converter-helper";
import { DwdmDiagramConverterModelsBuilder } from "./dwdm-diagram-converter-models-builder";
import {
    AmplifiersConverterData,
    IntermediatesConverterData,
    IntermediateElementIdentifier,
    OscsConverterData
} from "./dwdm-diagram-converter.models";

/**
 * Classe abstrata para realizar a conversão de @see IntermediatesConverterData em @see IntermediateDeviceElement.
 *
 * Essa classe contém todos os comportamentos comuns entre todas as janelas.
 * Comportamentos específicos da tela de Diagnósticos ou da Wizard de criação devem ser
 * implementados nas classes concretas.
 */
export abstract class DwdmDiagramAbstractConverterIntermediates {

    private readonly INTERMEDIATE_NAME_MAX_CHARS = 18;

    private readonly converterModelsBuilder: DwdmDiagramConverterModelsBuilder;
    private readonly cutStringPipe: CutStringPipe;

    constructor() {
        this.converterModelsBuilder = new DwdmDiagramConverterModelsBuilder();
        this.cutStringPipe = new CutStringPipe();
    }

    protected convertData(
            intermediatesData: IntermediatesConverterData,
            converters: {
                amplifiers: (data: AmplifiersConverterData) => AmplifierDirectionMap;
                oscs: (data: OscsConverterData) => OscPositionMap;
            }): IntermediateElementIdentifier[] {

        const hasIntermediates = intermediatesData.hasIntermediates;
        const intermediates = intermediatesData.intermediates;

        if (hasIntermediates && intermediates?.length > 0) {
            return intermediates.map(intermediate => {
                const amplifiersData = this.converterModelsBuilder.buildAmplifiersConverterDataForIntermediate(
                    intermediate, intermediatesData);
                const amplifiers = converters.amplifiers(amplifiersData);

                const oscsData = this.converterModelsBuilder.buildOscsConverterDataForIntermediate(
                    intermediate, intermediatesData);
                const oscs = converters.oscs(oscsData);

                return this.buildIntermediate(intermediate, amplifiers, oscs);
            });
        }

        return [];
    }

    private buildIntermediate(device: IntermediateDevice, amplifiers: AmplifierDirectionMap,
            oscPosition: OscPositionMap): IntermediateElementIdentifier {

        return {
            deviceResourceId: device.resourceId,
            intermediate: {
                id: DwdmDiagramConverterHelper.createId(),
                name: this.cutStringPipe.transform(device.name, this.INTERMEDIATE_NAME_MAX_CHARS),
                amplifiers,
                oscPosition,
                getCustomTooltip: () => device.name
            }
        };
    }
}
